<template>
  <div class="scan-code scan-code-yjs" v-if="yjs">
    <div class="activity-header-container">
      <div
        class="activity-header"
        :style="{
          paddingTop: stateHeight
        }"
      >
        <van-nav-bar :border="false" class="navbar" placeholder>
          <template #left>
            <div class="left">
              <img
                class="icon-back"
                src="../assets/img/activity/yjs/home_back.svg"
                @click="handleBack"
              />
            </div>
          </template>
        </van-nav-bar>
      </div>
    </div>
    <img class="title" src="@/assets/img/activity/yjs/scan_title.png" alt="" />
    <div class="scan-code-content">
      <div
        class="scan-code-img"
        :class="`${
          isWeChat ? 'wx yjs_wx_scanCode' : 'not_wx yjs_not_wx_scanCode'
        }`"
      >
        <img class="scan_code" :src="wechatQRImg" alt="" />
      </div>
    </div>
    <!-- <img class="scan_logo" src="@/assets/img/activity/scan_logo.png" /> -->
  </div>
  <div class="scan-code" v-else>
    <div class="activity-header-container">
      <div
        class="activity-header"
        :style="{
          paddingTop: stateHeight
        }"
      >
        <van-nav-bar :border="false" class="navbar" placeholder>
          <template #left>
            <div class="left">
              <img
                class="icon-back"
                src="../assets/img/activity/yjs/home_back.svg"
                @click="handleBack"
              />
            </div>
          </template>
        </van-nav-bar>
      </div>
    </div>
    <img class="title" src="@/assets/img/activity/scan_title.png" alt="" />
    <div class="scan-code-content">
      <div
        class="scan-code-img"
        :class="`${isWeChat ? 'wx wx_scanCode' : 'not_wx not_wx_scanCode'}`"
      >
        <img class="scan_code" :src="wechatQRImg" alt="" />
      </div>
    </div>
    <img class="scan_logo" src="@/assets/img/activity/scan_logo.png" />
  </div>
</template>
<script>
import router from "@/router";
export default {
  data() {
    return {
      stateHeight: 0,
      // yjs_wx: require("../assets/img/activity/yjs/wx_scanCode.png"),
      // yjs_not_wx: require("../assets/img/activity/yjs/not_wx_scanCode.png"),
    };
  },
  computed: {
    wechatQRImg() {
      return (
        this.$store.state.commonStore.wechatQRImg ||
        localStorage.getItem("wechatQRImg")
      );
    },
    isWeChat() {
      return this.$store.getters.appType === "weixin";
    },
    yjs() {
      return this.$store.getters.platform.indexOf("yjs") > -1;
    },
    accountId() {
      return this.$store.state.commonStore.accountId;
    },
    activityId() {
      return this.$store.state.commonStore.activityId;
    },
  },
  created() {},
  async mounted() {
    if(this.$store.state.commonStore.searchPage){
      this.stateHeight = '0px'
    }else{
      this.stateHeight = await this.$base.getAppStateHeight();
    }
  },
  methods: {
    handleBack() {
      router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
.scan-code {
  min-height: 100vh;
  background: url("@/assets/img/activity/scan_bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  text-align: center;
  .title {
    width: 331px;
    height: 118px;
    margin-top: 101px;
  }
  .scan-code-img {
    width: 373px;
    background-repeat: no-repeat !important;
    background-size: cover !important;
    text-align: center;
    margin: 11px auto 0;
  }
  .wx {
    height: 449px;
    .scan_code {
      height: 222px;
      width: 222px;
      margin: 99px auto 0;
    }
  }
  .not_wx {
    height: 468px;
    .scan_code {
      height: 222px;
      width: 222px;
      margin: 113px auto 0;
    }
  }
  .yjs_wx_scanCode {
    background: url("../assets/img/activity/yjs/wx_scanCode.png");
  }
  .yjs_not_wx_scanCode {
    background: url("../assets/img/activity/yjs/not_wx_scanCode.png");
  }
  .wx_scanCode {
    background: url("../assets/img/activity/wx_scanCode.png");
  }
  .not_wx_scanCode {
    background: url("../assets/img/activity/not_wx_scanCode.png");
  }
  .scan-code-img2 {
    margin-top: 11px;
    width: 373px;
    height: 468px;
  }
  .scan_logo {
    margin-top: 4px;
    width: 126px;
    height: 27px;
  }
  .activity-header-container {
    color: #222222;
    position: relative;
    .activity-header {
      min-height: 44px;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 999;
      .pc & {
        position: fixed;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        z-index: 999;
        width: 375px;
      }
      .left {
        display: flex;
      }
      /deep/.van-nav-bar {
        height: 44px;
        width: 100%;
        .van-nav-bar__content {
          height: 100%;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 16px 0 16px;
          position: relative;
          .van-nav-bar__title {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            font-size: 16px;
          }
        }
      }
      .icon-back {
        display: inline-block;
        width: 24px;
        height: 24px;
      }
    }
  }
}
.scan-code-yjs {
  background: url("@/assets/img/activity/yjs/scan_bg.jpg");
  background-repeat: no-repeat;
  background-size: contain;
}
</style>
